module.exports = __webpack_public_path__ + "static/media/ex-register.e3d92195.jpg";